<template>
<div id="main-content" class="taskboard">
        <div class="container-fluid">
            <div class="block-header">
                <div class="row">
                    <div class="col-lg-6 col-md-8 col-sm-12">
                        <h2><a href="javascript:void(0);" class="btn btn-xs btn-link btn-toggle-fullwidth"><i class="fa fa-arrow-left"></i></a> Tickets</h2>
                        <ul class="breadcrumb">
                            <li class="breadcrumb-item"><a href="index.html"><i class="icon-home"></i></a></li>                            
                            <li class="breadcrumb-item">Apps</li>
                            <li class="breadcrumb-item active">Tickets</li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- <div class="row clearfix">
                <div class="col-lg-3 col-md-6">
                    <div class="card">
                        <div class="body text-center">
                            <div class="sparkline-pie">5,3,2</div>
                            <h3 class="m-b-0 m-t-10">2078</h3>
                            <span >Total Tickets</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="card">
                        <div class="body text-center">
                            <input type="text" class="knob2" data-readOnly="true" value="50" data-width="90" data-height="90" data-thickness="0.15"  data-fgColor="#00ca70">
                            <h3 class="m-b-0 m-t-10">1278</h3>
                            <span>Resolve</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="card">
                        <div class="body text-center">
                            <input type="text" class="knob2" data-readOnly="true" value="30" data-width="90" data-height="90" data-thickness="0.15"  data-fgColor="#4b78b8">
                            <h3 class="m-b-0 m-t-10">521</h3>
                            <span>Pending</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="card">
                        <div class="body text-center">
                            <input type="text" class="knob2" data-readOnly="true" value="20" data-width="90" data-height="90" data-thickness="0.15"  data-fgColor="#ffbf00">
                            <h3 class="m-b-0 m-t-10">978</h3>
                            <span>Responded</span>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12">
                    <div class="card">
                        <div class="header">
                            <h2>Observation List</h2>
                        </div>
                        <div :style="{ display: 'flex', flexDirection: 'row', padding: '0px 20px' }">
                            <select class="form-control col-2" :id="'questionStatus'" v-model="searchStatus" @change="dataChanged" >
                                <option v-for="(list, index) in qsList" :key="index" :value="list['id']">{{ list['name'] }}</option>
                            </select>
                            <select class="form-control col-2" :id="'areaList'" v-model="searchArea" @change="dataAreaChanged" >
                                <option v-for="(list, index) in areaList" :key="index" :value="list['id']">{{ list['name'] }}</option>
                            </select>
                            <select class="form-control col-1" :id="'evidenceList'" v-model="searchEvidence" @change="dataEvidenceChanged" >
                                <option v-for="(list, index) in evidenceList" :key="index" :value="list['id']">{{ list['name'] }}</option>
                            </select>
                            <input v-model="searchKey" class="form-control" placeholder="Search here..." type="text" @keyup.enter="init">
                            <button type="button" class="btn btn-default" @click="init"><i class="icon-magnifier"></i></button>
                        </div>
                        <!-- <div :style="{ display: 'flex', flexDirection: 'row', padding: '0px 20px' }">
                            <div class="input-group mb-3">
                                <select class="form-control col-2" :id="'questionStatus'" v-model="searchStatus" @change="dataChanged" >
                                    <option v-for="(list, index) in qsList" :key="index" :value="list['id']">{{ list['name'] }}</option>
                                </select>
                                <select class="form-control col-2" :id="'areaList'" v-model="searchArea" @change="dataAreaChanged" >
                                    <option v-for="(list, index) in areaList" :key="index" :value="list['id']">{{ list['name'] }}</option>
                                </select>
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <input type="checkbox" v-model="searchEvidence" id="isVerifiedMember">
                                    </div>
                                </div>
                            <input v-model="searchKey" class="form-control" placeholder="Search here..." type="text" @keyup.enter="init">
                            <button type="button" class="btn btn-default" @click="init"><i class="icon-magnifier"></i></button>
                            </div>
                        </div> -->
                        <div class="body">
                            <app-modal :elements="modalElements" v-on:confirm="del"></app-modal>
                            <app-modal :elements="approveModalElements" v-on:confirm="approve"></app-modal>
                            <app-modal :elements="feedbackModalElements" v-on:confirm="feedback"></app-modal>
                            <app-modal :elements="invalidModalElements" v-on:confirm="invalid"></app-modal>
                            <button type="button" class="btn btn-outline-info" @click="edit">Edit <i class="far fa-edit"></i></button>
                            <button type="button" class="btn btn-outline-success" style="margin-left: 20px;" data-toggle="modal" :data-target="`#${approveModalElements.modalId}`">Approve <i class="fa fa-check"></i></button>
                            <button type="button" class="btn btn-outline-primary" style="margin-left: 20px;" data-toggle="modal" :data-target="`#${feedbackModalElements.modalId}`">Feedback <i class="fa fa-exclamation"></i></button>
                            <button type="button" class="btn btn-outline-dark" style="margin-left: 20px;" data-toggle="modal" :data-target="`#${invalidModalElements.modalId}`">Invalid <i class="fa fa-times"></i></button>
                            <button type="button" class="btn btn-outline-danger" style="margin-left: 20px;" data-toggle="modal" :data-target="`#${modalElements.modalId}`">Close <i class="far fa-trash-alt"></i></button>
                            <app-datatable :type="'view'" :elements="dtElements" :collections="ticket" v-on:selectedRow="selectRow" :canMultiple="true" v-on:selectedDatas="selectDatas"></app-datatable>
                            <app-data-pagination v-on:pageChanged="changePage"></app-data-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../../services/api'
import { ticket } from '../../models/ticket'
import AppDatatable from '../../components/AppDatatable.vue'
import AppModal from '../../components/AppModal.vue'
import AppDataPagination from '../../components/AppDataPagination.vue'
import AppDataSearch from '../../components/AppDataSearch.vue'
import AppDropdown from '../../components/AppDropdown.vue'

export default {
    components: {
        AppDatatable, AppModal, AppDataPagination, AppDataSearch, AppDropdown
    },
    data() {
        return {
            ticket: [ticket],
            dtElements: [
                {
                    title: 'QBO No.',
                    column: 'qboNo',
                    type: 'text'
                },
                {
                    title: 'Employee Name',
                    column: 'employeeName',
                    type: 'text'
                },
                {
                    title: 'Employee Number',
                    column: 'employeeNumber',
                    type: 'text'
                },
                {
                    title: 'Department',
                    column: 'department',
                    type: 'text'
                },
                {
                    title: 'Date',
                    column: 'date',
                    type: 'date'
                },
                {
                    title: 'Status',
                    column: 'questionStatus',
                    type: 'badge'
                },
                {
                    title: 'Category Level',
                    column: 'categoryLevel',
                    type: 'badge'
                },
                {
                    title: 'Area Observe',
                    column: 'areaObserve',
                    type: 'text'
                },
                {
                    title: 'Category Observe',
                    column: 'categoryObserve',
                    type: 'text'
                },
                {
                    title: 'Detail Category',
                    column: 'detailCategory',
                    type: 'text'
                },
                {
                    title: 'Evidence',
                    column: 'evidence',
                    type: 'text'
                },
                {
                    title: 'Remark',
                    column: 'remark',
                    type: 'text'
                },
                {
                    title: 'PIC',
                    column: 'PIC',
                    type: 'text'
                },
                // {
                //     title: 'Problem Machine',
                //     column: 'remarkMachineRootCause',
                //     type: 'text'
                // },
                // {
                //     title: 'Problem Man',
                //     column: 'remarkManRootCause',
                //     type: 'text'
                // },
                // {
                //     title: 'Problem Material',
                //     column: 'remarkMaterialRootCause',
                //     type: 'text'
                // },
                // {
                //     title: 'Problem Method',
                //     column: 'remarkMethodRootCause',
                //     type: 'text'
                // },
                // {
                //     title: 'Problem Environment',
                //     column: 'remarkEnvironmentRootCause',
                //     type: 'text'
                // },
                // {
                //     title: 'Correction Action',
                //     column: 'preventionAction',
                //     type: 'text'
                // },
                // {
                //     title: 'Correction Action By',
                //     column: 'preventionActionBy',
                //     type: 'text'
                // },
                // {
                //     title: 'Correction Action Date',
                //     column: 'preventionActionDate',
                //     type: 'text'
                // },
                // {
                //     title: 'Corrective Action',
                //     column: 'correctiveAction',
                //     type: 'text'
                // },
                // {
                //     title: 'Corrective Action By',
                //     column: 'correctiveActionBy',
                //     type: 'text'
                // },
                // {
                //     title: 'Corrective Action Date',
                //     column: 'correctiveActionDate',
                //     type: 'text'
                // }
            ],
            modalElements: {
                modalId: 'qbo',
                title: 'Confirm',
                content: 'Are you sure to delete this data?'
            },
            approveModalElements: {
                modalId: 'qbo-approve',
                title: 'Confirm',
                content: 'Are you sure to approve this data(s)?'
            },
            feedbackModalElements: {
                modalId: 'qbo-feedback',
                title: 'Confirm',
                content: 'Are you sure to feedback this data(s)?'
            },
            invalidModalElements: {
                modalId: 'qbo-invalid',
                title: 'Confirm',
                content: 'Are you sure to invalid this data(s)?'
            },
            selectedId: '',
            searchKey: '',
            searchStatus: '',
            searchArea: '',
            searchEvidence: 'All',
            pagination: {
                pageSize: 10,
                currentPage: 1
            },
            selectedDatas: [],
            qsList: [],
            areaList: [],
            evidenceList: [
                {
                    id: 'All',
                    name: 'All'
                },
                {
                    id: 'Yes',
                    name: 'Yes'
                },
                {
                    id: 'No',
                    name: 'No'
                },
            ],
        }
    },
    async created() {
        this.init()
    },
    methods: {
        async init() {
            const ticketApi = api('question-list/partial')
            const query = {
                params: {
                    searchKey: this.searchKey,
                    searchStatus: this.searchStatus,
                    searchArea: this.searchArea,
                    searchEvidence: this.searchEvidence,
                    currentPage: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize
                }
            }
            this.ticket = await ticketApi.getWithQuery(query) 

            const qsApi = api('question-status')
            this.qsList = await qsApi.get()

            const areaApi = api('area')
            this.areaList = await areaApi.get()
        },
        add() {
            this.$router.push({ name: 'qboAdminDetail' })
        },
        edit() {
            console.log(this.selectDatas);
            if(this.selectedDatas.length == 0 || this.selectedDatas.length > 1) {
                // do nothing
            } else if (this.selectedDatas.length == 1) {
                this.$router.push({
                    name: 'qboAdminDetail',
                    query: {
                        id: this.selectedDatas
                    }
                })
            }
            // if(this.selectedId !== '') {
            //     this.$router.push({
            //         name: 'qboAdminDetail',
            //         query: {
            //             id: this.selectedId
            //         }
            //     })
            // }
        },
        preview() {
        },
        async del() {
            // if(this.selectedId !== '') {
            //     const rsApi = api('')
            //     await rsApi.delete(this.selectedId)
            //     this.init()
            // }
        },
        async approve() {
            if(this.selectedDatas.length > 0) {
                for (let i=0; i<this.selectedDatas.length; i++) {
                    const qboApi = api('qbo-admin-approve')
                    await qboApi.update(
                    {
                        id: this.selectedDatas[i],
                    }, 
                    this.selectedDatas[i]);
                }
                this.init()
            }
        },
        async feedback() {
            if(this.selectedDatas.length > 0) {
                for (let i=0; i<this.selectedDatas.length; i++) {
                    const qboApi = api('qbo-admin-feedback')
                    await qboApi.update(
                    {
                        id: this.selectedDatas[i],
                    }, 
                    this.selectedDatas[i]);
                }
                this.init()
            }
        },
        async invalid() {
            if(this.selectedDatas.length > 0) {
                for (let i=0; i<this.selectedDatas.length; i++) {
                    const qboApi = api('qbo-admin-invalid')
                    await qboApi.update(
                    {
                        id: this.selectedDatas[i],
                    }, 
                    this.selectedDatas[i]);
                }
                this.init()
            }
        },
        selectRow(id) {
            this.selectedId = id
        },
        selectDatas(data) {
            this.selectedDatas = data
            console.log('selected datas', data);
        },
        changePage(payload) {
            this.pagination = payload
            this.init()
        },
        search(searchKey) {
            this.searchKey = searchKey
            this.init()
        },
        dataChanged(evt) {
            // const newData = {
            //     [this.keyName]: evt.target.value
            // }
            console.log('newdata', evt.target.value)
            this.searchStatus = evt.target.value
            // this.init()
        },
        dataAreaChanged(evt) {
            console.log('newdata', evt.target.value)
            this.searchArea = evt.target.value
        },
        dataEvidenceChanged(evt) {
            console.log('newdata', evt.target.value)
            this.searchEvidence = evt.target.value
            // this.init()
        }
    }
}
</script>